import * as api from '../datas/law'
// import * as tool from '../datas/js/tool'

export default {
  namespaced: true,
  state: {
    professional: [], // 专业列表
    orgs: [], // 发布机构列表
    industrys: [], // 行业列表
    forceLevel: [], // 效力等级
    forceStatus: [] // 效力状态
  },
  mutations: {
    setProfessional (state, data) {
      state.professional = data || []
    },
    setOrgs (state, data) {
      let list = data || []
      state.orgs = list
    },
    setIndustrys (state, data) {
      let list = data || []
      state.industrys = list
    },
    setforceLevel (state, data) {
      let list = data || []
      state.forceLevel = list
    },
    setforceStatus (state, data) {
      let list = data || []
      state.forceStatus = list
    }
  },
  actions: {
    getProfessionalList ({ commit }) {
      return api.getProfessionalList().then(res => {
        if (res.response.success) {
          commit('setProfessional', res.data)
        } else {
          console.log('[ got an error when getProfessionalList() in store ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ got an error when getProfessionalList() in store ]', error)
      })
    },
    getOrgs ({ commit }) {
      return api.getLaworgs().then(res => {
        if (res.response.success) {
          commit('setOrgs', res.data)
        } else {
          console.log('[ got an error when getOrgs() in store ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ got an error when getOrgs() in store ]', error)
      })
    },
    getIndustrys ({ commit }) {
      return api.getLawIndustrys().then(res => {
        if (res.response.success) {
          commit('setIndustrys', res.data)
        } else {
          console.log('[ got an error when getIndustrys() in store ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ got an error when getIndustrys() in store ]', error)
      })
    },
    getForceLevel ({ commit }) {
      return api.getLawForceLevelInfo().then(res => {
        if (res.response.msg) {
          commit('setforceLevel', res.data)
        } else {
          console.log('[ got an error when getForceLevel() in store ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ got an error when getForceLevel() in store ]', error)
      })
    },
    getForceStatus ({ commit }) {
      return api.getLawForceStatusInfo().then(res => {
        if (res.response.success) {
          commit('setforceStatus', res.data)
        } else {
          console.log('[ got an error when getForceStatus() in store ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ got an error when getForceStatus() in store ]', error)
      })
    }
  },
  getters: {
    professionalList (state) {
      return state.professional
    },
    orgs (state) {
      return state.orgs
    },
    industrys (state) {
      return state.industrys
    },
    forceLevel (state) {
      return state.forceLevel
    },
    forceStatus (state) {
      return state.forceStatus
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lawStore.js